import type { CategoryPreviewItem } from '@app/src/types/tabularImport'
import { Box, Chip, Typography } from '@mui/material'
import React from 'react'

type CategoryPreviewCellProps = {
  preview: CategoryPreviewItem[] | undefined
}

const CategoryPreviewCell: React.FC<CategoryPreviewCellProps> = ({ preview }) => {
  if (!preview || preview.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        -
      </Typography>
    )
  }

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
      {preview.map(item => (
        <Chip
          key={item.name}
          label={item.name}
          size="small"
          variant="outlined"
          color={item.isNew ? 'info' : 'default'}
        />
      ))}
    </Box>
  )
}

export default CategoryPreviewCell
